<div class="filter">
  <div class="material-symbols-outlined filter__icon" (click)="toggleFilter($event)">
    {{ value ? 'filter_1' : 'filter_list' }}
  </div>
  @if (filterOpened) {
    <div class="filter__input">
      <mat-form-field subscriptSizing="dynamic">
        <input matInput placeholder="Search" [(ngModel)]="value" (keydown.enter)="search()" />
        @if (value) {
          <button matSuffix matIconButton (click)="clear()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
      <button matIconButton (click)="search()">
        <mat-icon>filter_alt</mat-icon>
      </button>
    </div>
  }
</div>
